import styled from 'styled-components';

import { Box } from 'Components/Base';
import { withOffset } from 'Context/LayoutContext';

// FIXME: SKOOLDIO-5053 Remove APP_TOP_OFFSET param and use `safe area insets` instead
const BlankPaasLayout = styled(Box)`
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ theme }) => `${theme.space.APP_TOP_OFFSET}px 18px`};
  background-color: ${({ theme }) => theme.colors.contentBackground};
`;

export default withOffset(BlankPaasLayout);
